(function () {

    //Экран data
    const formBeneficiaryData = $('.form-beneficiary-data');
    const buttonBeneficiaryData = $('.button--beneficiary-data');
    const tabsName = formBeneficiaryData.find('.tabs__name');
    const tabsInput = formBeneficiaryData.find('#tabs__input');

    buttonBeneficiaryData.on('click', function () {
        console.log('clivk')
        if (!validator(formBeneficiaryData)) {
            buttonBeneficiaryData.remove('button--in-active');
            formBeneficiaryData.submit();
        } else {
            console.log('error')
            buttonBeneficiaryData.addClass('button--in-active');
        }
    })

    tabsName.on('click', function () {
        if ($(this).text() === 'Паспорт') {
            tabsInput.val('21')
        } else {
            tabsInput.val('03')
        }
    })
})();
